import { getPSMApiService } from '../utils/request'
import {
  ICreateImageTemplate,
  ICreateImageHmExtract,
  IGetImageQuality,
  IDescribeImageXLiteRequestCount,
  ICreateImageAnimTask,
  IGetImageAnimTaskDetail,
  ITerminateImageAnimTask,
  IGetUploadAuth,
  ICheckRisk,
  IGetSpeedtestUploadToken,
  IGetSpeedtestClientNetInfo,
  IGetSpeedtestClientDnsResolveInfo,
} from './imagex.interface'

const api = getPSMApiService<{
  CreateImageTemplate: ICreateImageTemplate
  DescribeImageXLiteRequestCount: IDescribeImageXLiteRequestCount
  CreateImageAnimTask: ICreateImageAnimTask
  GetImageAnimTaskDetail: IGetImageAnimTaskDetail
  TerminateImageAnimTask: ITerminateImageAnimTask
  CreateImageHmExtract: ICreateImageHmExtract
  GetImageQuality: IGetImageQuality
  GetUploadAuth: IGetUploadAuth
  CheckRisk: ICheckRisk
  GetSpeedtestUploadToken: IGetSpeedtestUploadToken
  GetSpeedtestClientNetInfo: IGetSpeedtestClientNetInfo
  GetSpeedtestClientDnsResolveInfo: IGetSpeedtestClientDnsResolveInfo
}>(
  {
    CreateImageTemplate: {
      method: 'post',
      messageError: false,
      throwBizError: true,
    },
    DescribeImageXLiteRequestCount: { messageError: false, throwBizError: true },
    CreateImageAnimTask: { method: 'post' },
    GetImageAnimTaskDetail: {},
    TerminateImageAnimTask: { method: 'post' },
    CreateImageHmExtract: { method: 'post', isJson: false },
    GetImageQuality: { method: 'post', isJson: true, messageError: false },
    GetUploadAuth: { method: 'post', isJson: true },
    CheckRisk: { throwBizError: true },
    GetSpeedtestUploadToken: {},
    GetSpeedtestClientNetInfo: {},
    GetSpeedtestClientDnsResolveInfo: { messageError: false },
  },
  {
    method: 'get',
    isJson: true,
  },
)

export const {
  CreateImageTemplate,
  DescribeImageXLiteRequestCount,
  CreateImageAnimTask,
  GetImageAnimTaskDetail,
  TerminateImageAnimTask,
  CreateImageHmExtract,
  GetImageQuality,
  GetUploadAuth,
  CheckRisk,
  GetSpeedtestUploadToken,
  GetSpeedtestClientNetInfo,
  GetSpeedtestClientDnsResolveInfo,
} = api
